import React from 'react';
import * as S from './style';

interface IProps {
  children?: React.ReactNode;
}

const MainTemplate = ({ children }: IProps) => (
  <S.MainTemplate>{children}</S.MainTemplate>
);

export default MainTemplate;
